import { useEffect, useRef, useState } from 'react';

const rotatingWords = ['AI Strategy', 'Branding', 'Web Design', 'Digital Growth', 'Motion'];

export default function PalmerHero() {
  const [wordIndex, setWordIndex] = useState(0);
  const [wordVisible, setWordVisible] = useState(true);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    intervalRef.current = setInterval(() => {
      setWordVisible(false);
      setTimeout(() => {
        setWordIndex((i) => (i + 1) % rotatingWords.length);
        setWordVisible(true);
      }, 300);
    }, 2200);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  return (
    <section
      className="relative bg-black min-h-screen flex flex-col"
      id="top"
      style={{ fontFamily: "'DM Sans', sans-serif" }}
    >
      {/* Top-right info block */}
      <div className="absolute top-20 right-6 z-10 text-right hidden lg:block">
        <p className="text-white/30 text-xs leading-relaxed" style={{ maxWidth: 180 }}>
          6+ years of digital time, shaping brands and websites creative direction.
        </p>
        <div className="mt-3 flex flex-col items-end gap-0.5">
          <span
            className="text-white text-xs font-medium transition-all duration-300"
            style={{ opacity: wordVisible ? 1 : 0, transform: wordVisible ? 'translateY(0)' : 'translateY(-6px)' }}
          >
            {rotatingWords[wordIndex]}
          </span>
          <span className="text-white/20 text-xs">↓</span>
        </div>
      </div>

      {/* Main content — fills screen, text at bottom */}
      <div className="flex-1 flex flex-col justify-end px-6 pt-28 pb-0">
        {/* Massive headline */}
        <div
          className={`transition-all duration-1000 ${mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <h1
            className="text-white font-semibold leading-none"
            style={{
              fontSize: 'clamp(56px, 9.5vw, 148px)',
              letterSpacing: '-0.04em',
              lineHeight: 0.92,
            }}
          >
            Pattern Dimensions
          </h1>
          <h1
            className="text-white font-semibold leading-none"
            style={{
              fontSize: 'clamp(56px, 9.5vw, 148px)',
              letterSpacing: '-0.04em',
              lineHeight: 0.92,
            }}
          >
            and Moments that
          </h1>
          <h1
            className="text-white font-semibold leading-none"
            style={{
              fontSize: 'clamp(56px, 9.5vw, 148px)',
              letterSpacing: '-0.04em',
              lineHeight: 0.92,
            }}
          >
            Connect and Leave a
          </h1>
          <h1
            className="text-white font-semibold leading-none"
            style={{
              fontSize: 'clamp(56px, 9.5vw, 148px)',
              letterSpacing: '-0.04em',
              lineHeight: 0.92,
            }}
          >
            Bold イメージ.
          </h1>
        </div>

        {/* Vimeo video reel — sits below headline, flush to bottom */}
        <div
          className={`mt-8 w-full overflow-hidden transition-all duration-1000 delay-300 ${mounted ? 'opacity-100' : 'opacity-0'}`}
          style={{ height: 'clamp(180px, 28vw, 400px)' }}
        >
          <iframe
            src="https://player.vimeo.com/video/315891633?autoplay=1&loop=1&muted=1&controls=0&title=0&byline=0&portrait=0&background=1"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            className="w-full h-full"
            style={{ pointerEvents: 'none', display: 'block' }}
            title="Reel"
          />
        </div>
      </div>

      {/* Bottom bar with scroll arrow */}
      <div className="border-t border-white/10 px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          {/* Scroll down arrow */}
          <div className="w-7 h-7 border border-white/30 rounded-full flex items-center justify-center">
            <i className="ri-arrow-down-line text-white text-xs"></i>
          </div>
          <span className="text-white/30 text-xs tracking-widest uppercase">Scroll</span>
        </div>
        <span className="text-white/20 text-xs tracking-widest uppercase">
          Nova AI Digital LLC — Est. 2020
        </span>
        <span className="text-white/20 text-xs hidden lg:block">
          New York, USA
        </span>
      </div>
    </section>
  );
}
